import { Box, FormControlLabel, Grid, Radio, Typography } from "@mui/material"
import React from "react"
import { IRadioCardGroupProps } from "./FormBigRadioButtons.interfaces"
import { StyledRadioBox } from "./FormBigRadioButtons.styled"
import { useTranslation } from "react-i18next"

const FormBigRadioButtons: React.FC<IRadioCardGroupProps> = (props) => {
  const { options, value, handleClick } = props
  const { t } = useTranslation()

  return (
    <Grid container gap="3px" marginBottom={2}>
      {options?.map((option, index) => {
        return (
          <Grid md={12} xs={12} key={index}>
            <StyledRadioBox
              onClick={() => handleClick && handleClick(option.value)} // TODO: change sort to id when implemented
              isSelected={value === option.value}>
              <FormControlLabel
                sx={{ margin: 0, display: "flex", alignItems: "start" }}
                value={option.value}
                control={<Radio sx={{ padding: 0 }} checked={value === option.value} />}
                label={
                  <Box ml={2}>
                    <Typography variant="h4">{t(option.labelKey || "", { defaultValue: option.labelDefault })}</Typography>
                    {option?.descriptionDefault && (
                      <Typography color="textSecondary">
                        {t(option.descriptionKey || "", { defaultValue: option.labelDefault })}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </StyledRadioBox>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default FormBigRadioButtons
